import { Box, FormControl, Grid } from "@mui/material";
import FormLabel from "../../../components/styled/FormLabel";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../../components/common/FormikControl";
import FormField from "../../../components/styled/FormField";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLocations, selectAllLocation } from "../../../slices/common";
import { CalendarIcon } from "../../../../assets/images/drawerIcons/calendarIcon";
import BsModal from "../../../components/common/BaseModal";
import CalendarModel from "./CalendarModel"
import { addSlotRequest, fetchSlotDetails, selectApheresisLoading } from "../../../slices/apheresis";
import moment from "moment";
const initialValues = {
    date: "",
    slot_id: "",
    manufacturing_id: ""
}
const AssignApheresisDateForm = ({ rowData, handleCloseModal, fetchUsers }) => {
    const dispatch = useDispatch()
    const isLoading = useSelector(selectApheresisLoading)
    const allLocation = useSelector(selectAllLocation)
    const [calendarOpen, setCalendarOpen] = useState(false);
    const [formValues, setFormValues] = useState(initialValues)
    const [autoApproved, setAutoApproved] = useState(false)

    const getSlotDewtails = async () => {
        const res = await dispatch(fetchSlotDetails(rowData.subject_id)).unwrap()
        const data = res?.data
        if (data?.id) {
            setAutoApproved(true)
            setFormValues({ ...formValues, manufacturing_id: data.location_id })
        }
    }


    const getLocations = async () => {
        await dispatch(fetchLocations())
    }

    useEffect(() => {
        getSlotDewtails()
        getLocations()
    }, [])

    const validationSchema = Yup.object().shape({
        date: Yup.string().required("Date is required"),
        manufacturing_id: Yup.string().required("Facility is required"),
    })

    const handleSubmit = async (values) => {
        try {
            await dispatch(addSlotRequest({ ...values,feasibility_assessment_id: rowData?.id, slot_id: values.slot_id, subject_id: rowData?.subject_id }))
            fetchUsers()
        } catch (err) {
            console.error(err);
        } finally {
            handleCloseModal();
        }
    }

    const formik = useFormik({
        initialValues: formValues,
        enableReinitialize: true,
        validationSchema,
        onSubmit: handleSubmit
    })


    const formOptions = [
        {
            label: 'Manufacturing Facility',
            type: 'select',
            disabled: autoApproved,
            name: 'manufacturing_id',
            required: true,
            placeholder: 'Select Manufacturing Facility',
            options: allLocation?.items?.map(op => { return { value: op.id, label: op.name } })

        },
        {
            label: 'Requested Slot',
            type: 'text',
            name: 'date',
            required: false,
            placeholder: 'Select requested slot',
        },
    ]
    const handleCloseCalendarModal = () => {
        setCalendarOpen(false);
    };

    const handleSelectedSlot = (id, date, event = "", manufacturing_id) => {
        if (manufacturing_id) {
            formik.setFieldValue("manufacturing_id", manufacturing_id)
            console.log(event)
        } else {
            formik.setFieldValue("slot_id", id)
            formik.setFieldValue("slot_name", "Slot")
            formik.setFieldValue("date", moment(date).format("DD/MM/YYYY"))
        }
    }

    return (
        <Box>
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2} className="mb-3">
                    {formOptions.map((props, key) => (
                        <Grid key={key} item xs={12}>
                            {key == 1
                                ? <FormControl variant="standard" fullWidth={true} >
                                    <Box className="relative">
                                        <FormLabel shrink required={true}>Requested Slot</FormLabel>
                                        <FormField
                                            fullWidth={true}
                                            type={"text"}
                                            name={"date"}
                                            format="DD/MM/YYYY"
                                            value={formik.values["date"] || ""}
                                            placeholder={"Select requested slot"}
                                            onClick={() => {
                                                setCalendarOpen(true)
                                            }}
                                            aria-readonly={true}
                                            error={Boolean(formik.touched["date"] && formik.errors["date"])}
                                            helperText={formik.touched["date"] && formik.errors["date"]}
                                        // disabled={true}
                                        />
                                        <div className="absolute top-[2rem] right-[10px]"
                                            onClick={() => {
                                                setCalendarOpen(true)
                                            }}
                                        ><CalendarIcon /></div>
                                    </Box>
                                </FormControl>
                                : <FormikControl formik={formik} {...props} />
                            }
                        </Grid>
                    ))}
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <LoadingButton loading={isLoading} fullWidth type="submit" variant="contained">Submit</LoadingButton>
                    </Grid>
                </Grid>
            </form>
            <BsModal open={calendarOpen} size={"sm"} fullWidth={true} onClose={handleCloseCalendarModal} >
                <CalendarModel
                    disabledAction={autoApproved}
                    rageDate={rowData?.request_date}
                    handleSelectedSlot={handleSelectedSlot}
                    actionValues={formik.values}
                    handleCloseModal={handleCloseCalendarModal}
                    allPreferredDate={rowData?.preferred_date || []} />
            </BsModal>
        </Box>
    );
}

export default AssignApheresisDateForm;